import { LoginCallback } from '@okta/okta-react';
import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom';
import { RequiredAuth } from './common/okta/SecureRoute';
import { NEW_REQUEST, USER_LOGIN } from './constants/Constants';
import ExistingOrder from './pages/DuplicateRequestComponent/ExistingOrder';
import Home from './pages/HomeComponent/Home';
import InboundAutomation from './pages/InboundAutomationComponent/InboundAutomation';
import MainComponent from './pages/MainComponent/MainComponent';
import Success from './pages/SuccessComponent/Success';
import LoginComponent from './pages/login/LoginComponent';
import UserRegistration from './pages/userRegistration/UserRegistration';
import AboutBUPage from './pages/AboutBUComponent/AboutBUPage';

const Routes = () => {
      return (

            <RouterRoutes>

                  <Route path='*' element={<Navigate to={USER_LOGIN} />} />

                  <Route path={USER_LOGIN} element={<LoginComponent />} />

                  <Route path="/register" element={<UserRegistration />} />

                  <Route path="/dashboard" element={<RequiredAuth />}>
                        <Route path={""} element={<Home />} />
                  </Route>

                  <Route path="/Inbound-Automation" element={<RequiredAuth />}>
                        <Route path={""} element={<InboundAutomation />} />
                  </Route>

                  <Route path="/About-Business" element={<RequiredAuth />}>
                        <Route path={""} element={<AboutBUPage />} />
                  </Route>

                  <Route path={NEW_REQUEST} element={<RequiredAuth />}>
                        <Route path={""} element={<MainComponent />} />
                  </Route>

                  <Route path="/duplicate-request" element={<RequiredAuth />}>
                        <Route path={""} element={<ExistingOrder />} />
                  </Route>

                  <Route path="/success" element={<RequiredAuth />}>
                        <Route path={""} element={<Success />} />
                  </Route>

                  <Route path="/login/callback" element={<LoginCallback />} />

            </RouterRoutes>


      );
};

export default Routes;